import { omNotification } from '@owma/kit'

import { restClientNoToken as restClient } from 'myNet'

export default restClient

// const validateOTPURL = '/auth/validate/otp'
const sendEmailURL = '/auth/send/otp'
const loginURL = '/auth/login/otp'

// export async function validateOTP() {
//   return restClient
//     .get(validateOTPURL)
//     .then((response) => {
//       console.log('res = ', response)
//       return response
//     })
//     .catch((error) => {
//       omNotification.warning({
//         message: error.code,
//         description: error.message,
//       })
//     })
// }

interface OtpResponse {
  success: boolean
  otp_expires_in: number
}

export async function reqOtpCode(email: string): Promise<OtpResponse | undefined> {
  return restClient
    .post(sendEmailURL, { email })
    .then((res) => {
      if (import.meta.env.MODE && import.meta.env.MODE.indexOf('test') > -1) {
        if (res.data.otp != null) {
          // const log = getLogger({ name: '9folders' })
          console.log(`OTP CODE : ${res.data.otp}`)
        }
      }
      return {
        success: true,
        otp_expires_in: res.data.otp_expires_in,
      }
    })
    .catch((error) => {
      omNotification.warning({
        message: error.code,
        description: error.message,
      })
      return undefined
    })
}

export async function verifyOtpCode(email: string, loginCode: string): Promise<any> {
  return restClient.post(loginURL, { email, otp: loginCode })
}
